var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-form-add-permit-license",
      title: _vm.$t("Novo documento"),
      show: _vm.showSidebar,
      saving: _vm.saving,
      width: "500px",
    },
    on: { save: _vm.handlePermitLicenseSave, hidden: _vm.onHideSidebar },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              {
                ref: "permitLicenseSidebarForm",
                attrs: { name: "permitLicenseSidebarForm" },
              },
              [
                _c("FormulateInput", {
                  staticClass: "required",
                  attrs: {
                    type: "vue-select",
                    validation: "required",
                    label: _vm.$t("Tipo de documento"),
                    options: _vm.permitLicensesTypes(),
                    placeholder: _vm.$t("Selecione"),
                    disabled: _vm.saving,
                  },
                  model: {
                    value: _vm.permitLicenseForm.permitLicenseType,
                    callback: function ($$v) {
                      _vm.$set(_vm.permitLicenseForm, "permitLicenseType", $$v)
                    },
                    expression: "permitLicenseForm.permitLicenseType",
                  },
                }),
                _c("FormulateInput", {
                  staticClass: "required",
                  attrs: {
                    id: "permit-license-document",
                    type: "uploader",
                    deletable: "true",
                    "max-files": "1",
                    accept: ".pdf",
                    validation: "required",
                    disabled: _vm.saving,
                    "help-text": _vm.$t("Arraste e solte o documento aqui"),
                    "delete-confirm-message": _vm.$t(
                      "Tem certeza que deseja excluir o Documento?"
                    ),
                    meta: false,
                    label: _vm.$t("Documento"),
                  },
                  model: {
                    value: _vm.permitLicenseForm.permitLicenseDocument,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.permitLicenseForm,
                        "permitLicenseDocument",
                        $$v
                      )
                    },
                    expression: "permitLicenseForm.permitLicenseDocument",
                  },
                }),
                _c("FormulateInput", {
                  staticClass: "required",
                  attrs: {
                    type: "datepicker",
                    validation: "required",
                    placeholder: _vm.$t("dd/mm/aaaa"),
                    label: _vm.$t("Data de Vencimento"),
                    disabled: _vm.saving,
                  },
                  model: {
                    value: _vm.permitLicenseForm.dueDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.permitLicenseForm, "dueDate", $$v)
                    },
                    expression: "permitLicenseForm.dueDate",
                  },
                }),
                _vm.showObservation
                  ? [
                      _c("FormulateInput", {
                        attrs: {
                          label: _vm.$t("Observação"),
                          type: "textarea",
                          disabled: _vm.saving,
                        },
                        model: {
                          value: _vm.permitLicenseForm.observation,
                          callback: function ($$v) {
                            _vm.$set(_vm.permitLicenseForm, "observation", $$v)
                          },
                          expression: "permitLicenseForm.observation",
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }